import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';
//import ObtenerRubro from '../functions/ObtenerRubro';
import BusquedaSeleccionar from '../types/BusquedaSeleccionar';

interface SeleccionarBusquedaProps {
    busquedaInicial: number;
    onChange: (busqueda: BusquedaSeleccionar | null) => void;
    onClear: () => void;
    eliminando: boolean;
  }

const SeleccionarBusqueda: React.FC<SeleccionarBusquedaProps> = ({ busquedaInicial, onChange, onClear, eliminando }) => {

    const [busquedas, setBusquedas] = useState<BusquedaSeleccionar[]>([]);
    const [busquedaSeleccionada, setBusquedaSeleccionada] = useState<BusquedaSeleccionar | null>({id: 0, busqueda: ''});

    const handleBusquedaChange = (event: React.SyntheticEvent, newValue: BusquedaSeleccionar | null) => {

        setBusquedaSeleccionada(newValue);
        if (onChange) {
            onChange(newValue);
        }

        if (newValue === null && onClear) {
            onClear();
        }
    };

    const fetchBusquedas = async () => {
        
        //const dataBusquedas = {"busquedas_ok":"si","busquedas":[{"id":1,"busqueda":"BUSCADOR GENERAL"},{"id":2,"busqueda":"FARMACIAS"},{"id":3,"busqueda":"VADEMCUM"},{"id":4,"busqueda":"VADEMECUM ONCOLOGICO"}]};
        const dataBusquedas = {"busquedas_ok":"si","busquedas":[{"id":1,"busqueda":"BUSCADOR GENERAL"},{"id":2,"busqueda":"FARMACIAS"},{"id":3,"busqueda":"VADEMCUM"}]};
        //await ObtenerBusquedas();
        if (dataBusquedas.busquedas_ok === 'si') {
            const busquedasRecuperadas: BusquedaSeleccionar[] = [];
            for (const busqueda of dataBusquedas.busquedas) {
                busquedasRecuperadas.push({
                    id: busqueda.id,
                    busqueda: busqueda.busqueda
                });
            }

            setBusquedas(busquedasRecuperadas);

            if (busquedaInicial > 0) {
                const busquedaInicio = dataBusquedas.busquedas.find(
                    (r: BusquedaSeleccionar) => r.id === busquedaInicial
                );
                if (busquedaInicio) {
                    const busquedaInicioOK: BusquedaSeleccionar = {
                        id: busquedaInicio.id,
                        busqueda: busquedaInicio.busqueda
                    };
                    setBusquedaSeleccionada(busquedaInicioOK);
                    onChange(busquedaInicioOK);
                }
            }

        }
    };

    useEffect(() => {
        fetchBusquedas()
    }, []);

    useEffect(() => {
        if (busquedaInicial === 0) {
            setBusquedaSeleccionada(null);
        } else {
            const busquedaInicio = busquedas.find(
                (r: BusquedaSeleccionar) => r.id === busquedaInicial
            );
            if (busquedaInicio) {
                const busquedaInicioOK: BusquedaSeleccionar = {
                    id: busquedaInicio.id,
                    busqueda: busquedaInicio.busqueda
                };
                setBusquedaSeleccionada(busquedaInicioOK);
                onChange(busquedaInicioOK);
            }
        }
    }, [busquedaInicial]);


    /*useEffect(() => {
        fetchRubros()
    }, [rubroInicial]);*/

    return (
        <div className="flex flex-col w-full">
            <Autocomplete<BusquedaSeleccionar>
                options={busquedas}
                getOptionLabel={(option: BusquedaSeleccionar) => `${option.busqueda}`}
                renderInput={(params) => <TextField {...params} label="Selecciona qué buscar en las siguientes opciones"
                sx={{
                        '& .MuiInputBase-root': {
                            height: '39px',
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: '4px 14px', // Ajustamos el padding vertical
                            height: '20px', // Reducimos la altura del input
                            display: 'flex',
                            alignItems: 'center',
                        },
                        '& .MuiAutocomplete-input': {
                            padding: '0 !important', // Eliminamos el padding adicional del input del Autocomplete
                        },
                        '& .MuiInputLabel-root': {
                            transform: 'translate(14px, 8px) scale(1)',
                        },
                        '& .MuiInputLabel-shrink': {
                            transform: 'translate(14px, -9px) scale(0.75)',
                        },
                    }}
                    inputProps={{
                        ...params.inputProps,
                        readOnly: true,
                      }}            
                />}
                value={busquedaSeleccionada}
                onChange={handleBusquedaChange}
                isOptionEqualToValue={(option: BusquedaSeleccionar, value: BusquedaSeleccionar) => option.id === value.id}
                renderOption={(props, option: BusquedaSeleccionar) => (
                <li {...props}>
                    {option.busqueda}
                </li>
                )}
                disabled={eliminando}
            />
        </div>
    );
}

export default SeleccionarBusqueda;